import "./projectsList.scss";
export default function projectsList({id,title,active, setSelected}) {
    return (
        <li className={active ? "projectsList active" : "projectsList" }
         onClick={()=> setSelected(id) } >
            {title}
        </li>
    )
}
